/**
 * Что показать в значке непросмотренной реакции (заказ владельца 2026-09-09).
 *
 * <p>Вынесено из {@code UnseenReactionBadge} отдельным модулем, потому что здесь живёт
 * решение, которое можно проверить без экрана: показывать ли значок вообще. Сам компонент
 * после этого занят только анимацией и рисовкой.
 *
 * <p>Числа рядом с иконкой нет — владелец отказался от «+N» (2026-09-09): значок отвечает на
 * вопрос «на меня отреагировали?», а не «сколько раз». Сколько именно и кто — видно в самой
 * переписке, куда значок и зовёт.
 */
export type UnseenReactionBadgeModel = { visible: false } | { visible: true; emoji: string };

export function unseenReactionBadgeModel(input: { emoji?: string | null }): UnseenReactionBadgeModel {
  const emoji = typeof input.emoji === 'string' ? input.emoji.trim() : '';
  return emoji ? { visible: true, emoji } : { visible: false };
}
